import React from 'react';
import '../../Styles/PartnerReg.css'; // Import the CSS file

const GetStartedSection = () => (
  <div className="get-started-section">
    <div className="get-started-text">
      <h2 className="get-started-title">Get Started - It only takes 10 minutes</h2>
      <p className="get-started-description">
        Please be ready with the following for a smooth registration:
      </p>
      <ul className="get-started-list">
        <li className="get-started-list-item">
          <span className="checkmark">✔</span> PAN card
        </li>
        <li className="get-started-list-item">
          <span className="checkmark">✔</span> GST number, if applicable
        </li>
        <li className="get-started-list-item">
          <span className="checkmark">✔</span> Bank account details
        </li>
        <li className="get-started-list-item">
          <span className="checkmark">✔</span> Menu details and one dish image
        </li>
      </ul>
    </div>
    <div className="get-started-video">
      <iframe
        className="get-started-iframe"
        height="200"
        src="https://www.youtube.com/embed/dQw4w9WgXcQ"
        title="Introduction Video"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  </div>
);

export default GetStartedSection;
